export type Task = {
  id: string
  link: string
  name: string
  reward_amount: number
  type: TaskType
  is_available: boolean
  user_tasks: [
    {
      id: number
      user_id: string
      task_id: string
      is_collected: boolean
    }
  ]
}

export const enum TaskType {
  SUBSCRIPTION = 'subscription'
}
